import { Component, Input } from '@angular/core';
import { LinkStatus } from '../../../user.model';

@Component({
    selector: 'app-family-member-button',
    templateUrl: './family-member-button.component.html',
    styleUrls: ['./family-member-button.component.scss'],
})
export class FamilyMemberButtonComponent {
    @Input() firstName: string;
    @Input() lastName: string;
    @Input() picture: string;
    @Input() active: boolean;
    @Input() showWarning = false;
    @Input() linkStatus?: LinkStatus;

    get initials(): string {
        return this.getInitials(this.firstName, this.lastName);
    }

    getInitials(firstName, lastName): string {
        return firstName.charAt(0) + lastName.charAt(0);
    }
}
